// extracted by mini-css-extract-plugin
export default {"scrollHide":"scrollHide_scrollHide__HheiE"};